import spec from '../../shared/competency_framework.json'

export const FRAMEWORK_COPY = spec.copy
export const FRAMEWORK_FIELD_LABELS = spec.fieldLabels as Record<string, string>
export const FRAMEWORK_FIELDS = spec.briefFields as string[]

const ABSTRACT = new Set(spec.abstractTraits.map((item) => item.toLowerCase()))

function folded(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function isAbstractTrait(text: string): boolean {
  const value = folded(text)
  if (!value) return false
  if (ABSTRACT.has(value)) return true
  for (const prefix of ['a ', 'an ', 'the ', 'is a ', 'is an ']) {
    if (value.startsWith(prefix) && ABSTRACT.has(value.slice(prefix.length))) return true
  }
  return false
}

export function isObservableBehaviour(text: string): boolean {
  const value = text.trim()
  if (value.split(/\s+/).filter(Boolean).length < 4) return false
  return !isAbstractTrait(value)
}

export function tracesToBrief(excerpt: string, fieldValue: string): boolean {
  const haystack = folded(fieldValue)
  const needle = folded(excerpt)
  return Boolean(needle) && Boolean(haystack) && haystack.includes(needle)
}

export function fieldLabel(field: string): string {
  return FRAMEWORK_FIELD_LABELS[field] || field
}
